import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// @material-ui/core components
import Search from '@material-ui/icons/Search';
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import SnackbarContent from 'components/Snackbar/SnackbarContent.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import ChatInput from 'components/CustomInput/ChatInput.jsx';
import NavPills from 'components/NavPills/NavPills.jsx';
import ChatMap from './ChatMap';
import Style from 'assets/jss/material-dashboard-pro-react/views/chatStyle';

function Chat(props) {
  const [ searchFor, setSearchFor ] = useState("");

  function updateSearchFor(e) {
    setSearchFor(e.target.value);
  }

  function compareIgnoreCase(field, criteria) {
    if (!criteria) return true;
    if (!field) return false;
    return field.toLowerCase().includes(criteria.toLowerCase());
  }

  function filterPartyName(party, criteria) {
    return compareIgnoreCase(party.firstName, criteria) || compareIgnoreCase(party.lastName, criteria);
  }

  const { classes, uid, user } = props;
    return (
      <div>
          <GridContainer justify="center">
            <GridItem style={{ marginTop: '-40px' }} xs={11}>
              <SnackbarContent
                message={
                  <b>
                    Welcome to Chat! To get started, fill out your profile, add a
                    case, & assign a lawyer whom accepts, to begin your consultation.
                  </b>
                }
                color="info"
              />
            </GridItem>
            <GridItem xs={11}>
              <NavPills
                color="primary"
                alignCenter
                tabs={[
                  {
                    tabButton: 'Lawyers',
                    tabContent: (
                      <div>
                        <Card
                          style={{
                            margin: '0',
                          }}
                        >
                          <div
                            style={{
                              width: '95%',
                              margin: '0 auto',
                              marginTop: '0px',
                            }}
                          >
                            <Search
                              style={{
                                color: '#aaa',
                                marginBottom: '-8px',
                                marginRight: '10px',
                              }}
                              className={
                                classes.headerLinksSvg + ' ' + classes.searchIcon
                              }
                            />

                            <ChatInput
                              formControlProps={{
                                className: classes.top + ' ' + classes.search,
                                style: { margin: '9px 0 0 0', width: '85%' },
                              }}
                              id="chatLawyerQuery"
                              inputProps={{
                                placeholder: 'Search...',
                                inputProps: {
                                  'aria-label': 'Search',
                                  className: classes.searchInput,
                                },
                                onChange: updateSearchFor
                              }}
                            />
                          </div>
                        </Card>
                        <ChatMap filter={party=>party.userType==='lawyer' && filterPartyName(party, searchFor)} />
                      </div>
                    ),
                  },
                  {
                    tabButton:  user.userType === 'lawyer' ? 'Clients'  : 'Collaborators',
                    tabContent: (
                      <span>
                        <Card style={{ margin: '0' }}>
                          <div
                            style={{
                              width: '95%',
                              margin: '0 auto',
                              marginTop: '0px',
                            }}
                          >
                            <Search
                              style={{
                                color: '#aaa',
                                marginBottom: '-8px',
                                marginRight: '10px',
                              }}
                              className={
                                classes.headerLinksSvg + ' ' + classes.searchIcon
                              }
                            />

                            <ChatInput
                              formControlProps={{
                                className: classes.top + ' ' + classes.search,
                                style: { margin: '9px 0 0 0', width: '85%' },
                              }}
                              id="chatClientQuery"
                              inputProps={{
                                placeholder: 'Search...',
                                inputProps: {
                                  'aria-label': 'Search',
                                  className: classes.searchInput,
                                },
                                onChange: updateSearchFor
                              }}

                            />
                          </div>
                        </Card>
                        <ChatMap filter={party=>party.userType==='client' && filterPartyName(party, searchFor)} />
                      </span>
                    ),
                  },
                ]}
              />
            </GridItem>
            <div style={{ margin: '65px' }} />
          </GridContainer>
      </div>
    );

}

Chat.propTypes = {
  uid: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    uid: state.auth.user.uid,
    user: state.user.user
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(Chat);
